
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-series-plug-in-solar-battery",
      function () {
        return require("private-next-pages/stream-series-plug-in-solar-battery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-series-plug-in-solar-battery"])
      });
    }
  